import {Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Pipe({
  name: 'monthsShortName'
})
export class DateMonthShortNamePipe implements PipeTransform {

  constructor(private translateService: TranslateService) {
  }

  transform(value: number): string | number {
    switch (value) {
      case 1:
        return this.translateService.instant('months.short.january');
      case 2:
        return this.translateService.instant('months.short.february');
      case 3:
        return this.translateService.instant('months.short.march');
      case 4:
        return this.translateService.instant('months.short.april');
      case 5:
        return this.translateService.instant('months.short.may');
      case 6:
        return this.translateService.instant('months.short.june');
      case 7:
        return this.translateService.instant('months.short.july');
      case 8:
        return this.translateService.instant('months.short.august');
      case 9:
        return this.translateService.instant('months.short.september');
      case 10:
        return this.translateService.instant('months.short.october');
      case 11:
        return this.translateService.instant('months.short.november');
      case 12:
        return this.translateService.instant('months.short.december');
      default:
        return value;
    }
  }
}
